import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import * as InventoryActions from './inventory.actions';
import { InventoryService } from './inventory.service';
import { map } from 'rxjs';
import { CartActions } from '@us/web/cart/data-access';
import { OrdersActions } from '@us/web/orders/data-access';
import { AppInit } from '@us/web/shared/app';

@Injectable()
export class InventoryEffects {
    init$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(
                AppInit,
                InventoryActions.init,
                CartActions.submitCartSuccess,
                OrdersActions.completeOrder,
                OrdersActions.loadOrder
            ),
            fetch({
                run: () => {
                    return this.inventoryService
                        .getData()
                        .pipe(map(items => InventoryActions.loadInventorySuccess({ items: items })));
                },
                onError: (action, error) => {
                    console.error('Error', error);
                    return InventoryActions.loadInventoryFailure({ error });
                }
            })
        );
    });

    constructor(private readonly actions$: Actions, private inventoryService: InventoryService) {}
}
